module.exports = __webpack_public_path__ + "img/intelligent5.30e41acf.png";